import {
  NightOutline24Icon,
  PersonOutline24Icon,
  SpeechBubbleOutline24Icon,
} from "@vygruppen/spor-icon-react";
import { useAuth } from "app/Auth/AuthBoundary";
import { LanguageSwitch } from "features/Header/Menu/adminLinks/LanguageSwitch";
import { mailLink } from "features/Header/Menu/adminLinks/MailLink";
import { useTranslation } from "react-i18next";
import {
  DropsButton,
  Flex,
  Switch,
  Text,
  useColorMode,
} from "shared/components/Spor";
import styled from "styled-components";

const AdminLinkList = styled.ul`
  position: relative;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  list-style: none;
  width: 100%;
  padding: 0;
  margin: 0rem 0 0;
  gap: 6px;

  padding-top: 18px;
  padding-bottom: 10px;

  background-color: ${({ theme }) => theme.colorBackgroundMain};
`;

export const AdminLinkItem = styled.li`
  display: flex;

  align-items: center;
  width: 100%;
  justify-content: space-between;
  padding: 6px 18px;
  color: ${({ theme }) => theme.colorTextMain};
`;

const RowContainer = styled.a`
  display: flex;
  width: 100%;
  justify-content: start;
  flex-direction: row;
  text-decoration: none;
  transition: color 0.2s linear;

  padding: 0px 6px;

  &:hover {
    color: ${({ theme }) => theme.colorTextDisabled};

    & svg path {
      fill: ${({ theme }) => theme.colorTextMain};
    }
  }
`;

const AdminLinks = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  const { t } = useTranslation();
  const { signOut } = useAuth();

  return (
    <AdminLinkList>
      <LanguageSwitch />
      <AdminLinkItem>
        <Flex>
          <NightOutline24Icon />
          <Text variant="sm" pl="0.375rem">
            {t("Mørk modus")}
          </Text>
        </Flex>
        <Switch
          size="sm"
          checked={colorMode === "dark"}
          onChange={toggleColorMode}
          title={t("Mørk modus")}
        />
      </AdminLinkItem>
      <RowContainer
        href={mailLink(t)}
        target="_blank"
        rel="noopener noreferrer"
      >
        <DropsButton
          leftIcon={<SpeechBubbleOutline24Icon />}
          variant="ghost"
          size="sm"
          w="100%"
        >
          <Text variant="sm" fontWeight={100} w="100%" textAlign="left">
            {t("Tilbakemelding")}
          </Text>
        </DropsButton>
      </RowContainer>
      <RowContainer>
        <DropsButton
          onClick={signOut}
          leftIcon={<PersonOutline24Icon />}
          variant="ghost"
          size="sm"
          w="100%"
          aria-label="Log out"
        >
          <Text variant="sm" fontWeight={100} w="100%" textAlign="left">
            {t("Logg ut av Dashboard")}
          </Text>
        </DropsButton>
      </RowContainer>
    </AdminLinkList>
  );
};

export default AdminLinks;
